import axios from '@/axios';
import { removeEmpty } from '@/utils/helpers';
import {
	getAllTransformer,
	getByIdTransformer,
	getFilteredTransformer,
	filteredPayloadTransformer,
	addEmployeeTransformer,
} from './transformer';
import * as types from '../../mutation-types';

export default {
	namespaced: true,

	state: {
		employees: [],

		activeEmployee: null,
	},

	actions: {
		async fetchAllEmployee(_, { Page, PerPage, Status, OrderByBirthDate, OrderByNum, OrderByStartDate }) {
			return axios
				.get('/Employee', {
					params: { Page, PerPage, Status: Number(Status), IncludeContactInfo: true, OrderByBirthDate, OrderByNum, OrderByStartDate },
				})
				.then((res) => {
					const count = res.headers['x-pagination-total-count'];
					const data = res.data;
					console.log(res.data[0])
					return { data: data.map((e) => getAllTransformer(e)), count };
				});
		},

		async fetchFilteredEmployees(_, { Page, PerPage, Status, ...props }) {
			const payload = filteredPayloadTransformer(props);

			// const CERTIFICATE_QUERY = props.academicDegrees
			// 	? props.academicDegrees.map((c) => `Certificate=${c}`).join('&')
			// 	: '';
			// const SPECIFICATION_QUERY = props.academicSpecifications
			// 	? props.academicSpecifications.map((c) => `AcademicQualificationsIds=${c}`).join('&')
			// 	: '';

			return axios
				.get(
					'/Employee?' + payload.queryString,
					removeEmpty({
						params: {
							Page,
							PerPage,
							Status: Number(Status),
							...payload.params,
						},
					}),
				)
				.then((res) => {
					const count = res.headers['x-pagination-total-count'];
					const data = res.data;
					return { data: data.map((e) => getFilteredTransformer(e)), count };
				});
		},

		async fetchEmployeeById({ commit }, id) {
			return axios.get('/Employee/' + id).then(({ data }) => {
				commit(types.ACTIVE_EMPLOYEE, data);
				return getByIdTransformer(data);
			});
		},

		async addEmployee(_, { id, ...props }) {
			const temp = addEmployeeTransformer(props);

			return id ? axios.put('/Employee/' + id, temp) : axios.post('/Employee/', temp);
		},

		async fetchBriefEmployees({ commit }) {
			return axios.get('/Employee/Briefs').then(({ data }) => {
				commit('root', data);
				return data;
			});
		},

		async addAttachment(_, props) {
			const formData = new FormData();
			formData.append('EmployeeId', props.employeeId);
			formData.append('FormFile', props.file);
			formData.append('Name', props.file.name);

			return axios.post('/Employee/AttachedFile', formData);
		},

		async getAttachments(_, id) {
			return axios.get(`/Employee/${id}/AttachedFiles`).then(({ data }) => data);
		},

		async changeCode(_, { id, code }) {
			return axios.put(`/Employee/${id}/code`, null, { params: { code } });
		},

		async fetchLastCode() {
			return axios.get('/Employee/code').then(({data}) => {
				return data
			})
		}
	},

	mutations: {
		root(state, employees) {
			state.employees = employees;
		},
		[types.ACTIVE_EMPLOYEE](state, employee) {
			state.activeEmployee = employee;
		},
		[types.DIS_ACTIVATE_EMPLOYEE](state) {
			state.activeEmployee = null;
		},
	},

	getters: {
		getEmployeeById: state => id => state.employees.find(c => c.employeeId === id)
	}
};
